import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useConfig } from '@browsing/config';
import { isPlusSignupEnabled } from '@browsing/plus';
import { getQueryParam } from '@browsing/utils';

import { MyLoungeResponse } from '@shared/types/mylounge';
import { getCampaigns, getPersonalizedCampaigns } from '@client/services/api/mylounge';
import { getMylounge, fetchingCampaigns } from '@client/redux/modules/mylounge';

export const useMylounge = () => {
    const dispatch = useDispatch();
    const config = useConfig();

    const { openCampaigns, upcomingCampaigns, tabs, loading } = useSelector(getMylounge);

    // fallback in case of SSR failure
    useEffect(() => {
        const fetchMylounge = async () => {
            try {
                dispatch(fetchingCampaigns.started(null));

                let mylounge: MyLoungeResponse | null = null;
                if (config.isEnabled('upcoming')) {
                    const startedDate = getQueryParam('date') || new Date(Date.now()).toISOString();

                    mylounge = await getCampaigns(startedDate);
                } else {
                    mylounge = await getPersonalizedCampaigns({
                        allowEligiblePlusAccess: isPlusSignupEnabled(config),
                    });
                }

                dispatch(
                    fetchingCampaigns.done({
                        result: mylounge,
                    }),
                );
            } catch (err) {
                dispatch(
                    fetchingCampaigns.failed({
                        error: 'Fetching campaigns failed',
                    }),
                );
            }
        };

        if (!loading && (!openCampaigns?.length || !upcomingCampaigns?.length || !tabs?.length)) {
            fetchMylounge();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { openCampaigns, upcomingCampaigns, tabs };
};
